import React, { useState } from 'react';
import './Register.css';
import api from '../../services/api';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const Register = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [username, setUsername] = useState('');
  const navigate = useNavigate();

  const validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Simple validation
    if (!username || !email || !password || !confirmPassword) {
      Swal.fire('All fields are required!', '', 'warning');
      return;
    }

    if (!validateEmail(email)) {
      Swal.fire('Invalid email format!', '', 'error');
      return;
    }

    if (password.length < 6) {
      Swal.fire('Password must be at least 6 characters!', '', 'error');
      return;
    }

    if (password !== confirmPassword) {
      Swal.fire('Passwords do not match!', '', 'error');
      return;
    }

    api
      .post("/auth/register", { email, password, username })
      .then((response) => {
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.user));

        Swal.fire({
          icon: 'success',
          title: 'Registration successful!',
          showConfirmButton: false,
          timer: 1500,
        }).then(() => navigate('/'));
      })
      .catch((error) => {
        console.error("Registration error:", error);
        Swal.fire(
          'Error!',
          error.response?.data?.message || 'Registration failed. Please try again.',
          'error'
        );
      });
  };

  return (
    <div className="register-background">
      <div className="register-overlay">
        <div className="register-container">
          <div className="register-form">
            <h2>Register</h2>
            <form onSubmit={handleSubmit}>
              <div className="input-group">
                <input
                  type="text"
                  className="input-field"
                  placeholder="Name"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>
              <div className="input-group">
                <input
                  type="email"
                  className="input-field"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="input-group">
                <input
                  type="password"
                  className="input-field"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <div className="input-group">
                <input
                  type="password"
                  className="input-field"
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="submit-btn">Register</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
